import NavigationBridge from "./features/navigation/NavigationBridge.tsx";
import { t, useStoreLanguage } from "./features/store-language/i18n.ts";
import "./App.css";
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import faIR from "antd/locale/fa_IR";
import enGB from "antd/locale/en_GB";
import arEG from "antd/locale/ar_EG";
import { applyDocumentLanguage, getDirection } from "./features/store-language/i18n.ts";
import "./features/store-language/language.css";
import { App as AntdApp, ConfigProvider } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import ShopRoutes from "./ShopRoutes.js";
import { AppFeedbackBridge } from "./components/shared/AppFeedback.tsx";
import AppErrorBoundary from "./components/shared/AppErrorBoundary.tsx";
import AgencySessionBoundary from "./components/Shop/Auth/AgencySessionBoundary.tsx";

const App = () => {
  const storeLanguage = useStoreLanguage();
  const { pathname } = useLocation();
  useLayoutEffect(function () { applyDocumentLanguage(); }, [pathname, storeLanguage]);
  return (
    <ConfigProvider
      direction={getDirection()}
      locale={storeLanguage === "en" ? enGB : storeLanguage === "ar" ? arEG : faIR}
      getPopupContainer={() => document.body}
      renderEmpty={() => (
        <p className="opacity-50 text-center my-5">{t("اطلاعاتی برای نمایش پیدا نشد.")} </p>
      )}
      theme={{
        token: {
          fontFamily: "var(--portal-ui-font)",
          // Designing layout header uses z-index 1050; keep overlays above it.
          zIndexPopupBase: 2000,
        },
      }}
    >
      <AntdApp>
        <NavigationBridge />
        <AppFeedbackBridge />
        <AppErrorBoundary>
          <AgencySessionBoundary>
            <ShopRoutes />
          </AgencySessionBoundary>
        </AppErrorBoundary>
      </AntdApp>
    </ConfigProvider>
  );
};

export default App;
